export default {
  terms:
    'Prin plasarea comenzii, ești de acord cu <TermsLink>Termenii și Condițiile</TermsLink> noastre și cu <PrivacyPolicyLink>Politica noastră de confidențialitate</PrivacyPolicyLink>.',
};
